import React from "react";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { determineTheme } from "@theme/config/theme.config";
import environmentSettings from "./constants/environmentSettings";

export function AppProvider({ children }) {
  const startUpState = useSelector((state) => state.StartUp);
  const themeName = {
    brand: startUpState.brand,
    queryTheme: startUpState.queryTheme,
  };
  const showOrHideChatbot = environmentSettings.useChatbot;
  window.zE("webWidget", showOrHideChatbot);

  const { brand, queryTheme } = themeName;
  const theme = determineTheme(brand, queryTheme);
  return <ThemeProvider theme={theme.file}>{children}</ThemeProvider>;
}

export default AppProvider;